import { render, staticRenderFns } from "./AuthPopup.vue?vue&type=template&id=9fbc0792&"
import script from "./AuthPopup.vue?vue&type=script&lang=js&"
export * from "./AuthPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fbc0792')) {
      api.createRecord('9fbc0792', component.options)
    } else {
      api.reload('9fbc0792', component.options)
    }
    module.hot.accept("./AuthPopup.vue?vue&type=template&id=9fbc0792&", function () {
      api.rerender('9fbc0792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Auth/Components/AuthPopup.vue"
export default component.exports